/**
 * Admin Studio v1 — AdminGlobalFab
 * Rendered once at layout root (outside scroll containers).
 * Reads config from AdminFabContext; returns null when no FAB is registered.
 *
 * Positioning uses CSS custom property --app-bottom-nav-h set by AppMobileBottomNav
 * to stay above the bottom navigation bar + iOS safe area.
 */
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAdminFab } from '@/context/AdminFabContext';
import { cn } from '@/lib/utils';

export function AdminGlobalFab() {
  const { config } = useAdminFab();

  if (!config) return null;

  const mobileOnly = (config.visibility ?? 'mobile') === 'mobile';

  return (
    <Button
      size="icon"
      className={cn(
        'fixed right-4 z-[70] h-14 w-14 rounded-full shadow-lg',
        mobileOnly && 'md:hidden',
        config.disabled && 'opacity-50 pointer-events-none'
      )}
      style={{
        bottom: 'calc(var(--app-bottom-nav-h, 72px) + 16px + env(safe-area-inset-bottom, 0px))',
      }}
      data-testid="fab-create"
      aria-label={config.ariaLabel}
      onClick={config.onClick}
      disabled={config.disabled}
    >
      {config.icon ?? <Plus className="h-6 w-6" />}
    </Button>
  );
}
